import React from "react";
import { FormBuilder, Form } from "@redriver/cinnamon";
import { Button } from "semantic-ui-react";
import {
  PermissionCheck,
  usePermission,
} from "features/../../../shared/components/auth";

import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import {
  updateReturnOnInvestmentLabel,
  getReturnOnInvestmentLabel,
} from "./actions";

const ReturnOnInvestmentLabel = ({ onSubmitted, dealerOfficeId }) => {
  const hasEditPermission = usePermission(
    Targets.ReturnOnInvestment,
    Actions.Edit,
  );

  return (
    <FormBuilder
      initialReadOnly={!hasEditPermission}
      loadAction={getReturnOnInvestmentLabel}
      loadParams={{ dealerOfficeId }}
      submitAction={updateReturnOnInvestmentLabel}
      submitParams={{ dealerOfficeId }}
      onSubmitted={onSubmitted}
      renderForm={(formProps, state, events) => (
        <Form {...formProps} className="return-on-investment-label-form">
          <Form.Input
            inline
            maxLength={100}
            label="ROI Label"
            field="label"
            width={16}
          />

          <Form.If condition={() => state.dirty}>
            <div className="action-buttons">
              <Button
                negative
                content="Cancel"
                onClick={() => events.onReset()}
              />
              <Button
                positive
                content="Save"
                onClick={() => events.onSubmit()}
              />
            </div>
          </Form.If>
        </Form>
      )}
    />
  );
};

export default ReturnOnInvestmentLabel;
